import { useState } from "react";
import { toast } from "sonner";
import { Loader2, MonitorSmartphone, CheckCircle2 } from "lucide-react";
import { api, apiError } from "../lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function DemoRequest() {
  const [f, setF] = useState({ establishment: "", responsable: "", email: "", telephone: "", postes: 1 });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/licenses/demo-request", { ...f, postes: Number(f.postes) || 1 });
      toast.success(data.message || "Demande envoyée");
      setDone(true);
    } catch (err) { toast.error(apiError(err, "Envoi impossible")); } finally { setBusy(false); }
  };

  return (
    <div className="mx-auto max-w-2xl px-4 py-16" data-testid="demo-request-page">
      <div className="mb-6 flex items-center gap-3">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#0E7C7B]/10 text-[#0E7C7B]"><MonitorSmartphone size={24} /></div>
        <div>
          <h1 className="font-display text-3xl font-bold text-navy">Demander une démo</h1>
          <p className="text-sm text-slate-500">Patient Vitalis Care — SIH hospitalier</p>
        </div>
      </div>

      {done ? (
        <div className="rounded-2xl border border-emerald-200 bg-emerald-50 p-8 text-center" data-testid="demo-success">
          <CheckCircle2 size={40} className="mx-auto mb-3 text-emerald-600" />
          <h2 className="font-display text-xl font-semibold text-navy">Demande enregistrée</h2>
          <p className="mt-2 text-sm text-slate-600">Votre profil d'établissement a été créé et est <b>en attente de validation</b>. Notre équipe vous contactera rapidement avec vos accès de démonstration.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4 rounded-2xl border border-slate-200 bg-white p-6">
          <div>
            <Label className="text-xs font-medium text-slate-500">Nom de l'établissement *</Label>
            <Input required value={f.establishment} onChange={set("establishment")} data-testid="demo-establishment" className="mt-1" placeholder="Hôpital / Clinique …" />
          </div>
          <div className="grid gap-4 sm:grid-cols-2">
            <div>
              <Label className="text-xs font-medium text-slate-500">Responsable *</Label>
              <Input required value={f.responsable} onChange={set("responsable")} data-testid="demo-responsable" className="mt-1" placeholder="Nom et prénom" />
            </div>
            <div>
              <Label className="text-xs font-medium text-slate-500">Email *</Label>
              <Input required type="email" value={f.email} onChange={set("email")} data-testid="demo-email" className="mt-1" placeholder="contact@etablissement.ci" />
            </div>
            <div>
              <Label className="text-xs font-medium text-slate-500">Téléphone</Label>
              <Input value={f.telephone} onChange={set("telephone")} data-testid="demo-telephone" className="mt-1" placeholder="+225 …" />
            </div>
            <div>
              <Label className="text-xs font-medium text-slate-500">Nombre de postes estimé</Label>
              <Input type="number" min="1" value={f.postes} onChange={set("postes")} data-testid="demo-postes" className="mt-1" />
            </div>
          </div>
          <Button type="submit" disabled={busy} data-testid="demo-submit" className="w-full rounded-full bg-[#0E7C7B] text-white hover:bg-[#0b6463]">
            {busy ? <Loader2 size={16} className="mr-2 animate-spin" /> : null} Envoyer ma demande de démo
          </Button>
          <p className="text-center text-[11px] text-slate-400">Un profil d'établissement en attente de validation sera créé.</p>
        </form>
      )}
    </div>
  );
}
